import { __, Alert, confirm } from 'modules/theme';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';
import APIManager from 'modules/common/apiManager';
import {
  ModalTrigger,
  Pagination,
  Button,
  ButtonCommonTheme,
  FormControl,
  Table,
  Label,
  DataWithLoader,
  FormGroup,
  ControlLabel
} from 'modules/theme';
import {
  ModalFooter,
  FormWrapper,
  FormColumn,
  ColumnTitle,
  InfoWrapper
} from 'modules/theme';
import { Tab, Tabs } from 'react-bootstrap';
import {
  InfoWrapperP,
  ModalButtonDesign
} from '../../../../common/styles/main';
import { Row } from '../styles';
import Select from 'react-select-plus/lib/Select';
import { modalType } from '../../../../../helpers/dotenv';
var uuid = require('uuid');

class CSATAddEdit extends Component {
  constructor(props) {
    super(props);

    this.saveData = this.saveData.bind(this);
    this.renderFormGroup = this.renderFormGroup.bind(this);
    this.showModal = this.showModal.bind(this);
    this.hideModal = this.hideModal.bind(this);
    this.getCSATById = this.getCSATById.bind(this);
    this.handleModalGreetings = this.handleModalGreetings.bind(this);
    this.handleModalGreetingsEnd = this.handleModalGreetingsEnd.bind(this);
    this.handleModalQuestions = this.handleModalQuestions.bind(this);

    this.assignedToOptions = {
      TRANSFER_ON_AGENT_HANGUP: 'Transfer on agent hangup'
    };

    this.mAPI = new APIManager();
    // if (this.props.editData) {
    //   this.state = {
    //     name: this.props.editData.name,
    //     show: false
    //   };
    // } else {
    // }
    let editData = this.props.editData || {};
    this.state = {
      show: false,
      loading: false,
      name: '',
      description: '',
      intro: {
        fileId: '',
        file: ''
      },
      method: 'TRANSFER_ON_AGENT_HANGUP',
      questions: {
        config: {
          keypad: true,
          speech: false,
          allowIntruption: false
        },
        list: []
      },
      end: {
        fileName: '',
        fileId: '',
        type: 'string'
      },
      tags: [],
      showGreetings: false,
      showGreetingsEnd: false,
      showQuestions: false
    };
  }

  componentDidMount = () => {
    if (this.props.editData && this.props.editData._id) {
      this.getCSATById(this.props.editData._id);
    } else {
      console.log('Csat Edit not found');
    }
  };

  handleModalGreetings() {
    this.setState({ showGreetings: !this.state.showGreetings });
  }

  handleModalGreetingsEnd() {
    this.setState({ showGreetingsEnd: !this.state.showGreetingsEnd });
  }

  handleModalQuestions() {
    this.setState({ showQuestions: !this.state.showQuestions });
  }

  showModal = () => {
    this.setState({ show: true });
  };

  hideModal = () => {
    this.setState({ show: false });
  };

  generateParamsFromArray(tData) {
    let options = [];
    for (const key in tData) {
      options.push({
        value: key,
        label: tData[key]
      });
    }
    return options;
  }

  renderFormGroup(label, props) {
    if (props.defaultValue == '') {
      delete props.defaultValue;
    }
    return (
      <FormGroup>
        <ControlLabel required={props.required}>{label}</ControlLabel>
        <FormControl {...props} />
      </FormGroup>
    );
  }

  resetAllData() {
    this.setState({
      name: ''
    });
  }

  apiResponse(errorCode, data) {
    if (errorCode === 201) {
      // Alert.success(`${data.message}`);
      let message = data && data.message ? data.message : "Successfully Done";
      Alert.success(message);
      this.resetAllData();
      this.props.closeModal(true);
    } else {
      // Alert.error(`${data.message}`);
      let message = data && data.message ? data.message : "Something wrong happened";
      Alert.error(message);
    }
  }

  saveData(e) {
    e.preventDefault();
    let Name = this.state.name || "";
    Name = Name.trim();
    let tData = {
      name: Name,
      description: this.state.description,
      method: this.state.method,
      intro: this.state.intro,
    };
    if (this.props.editData) {
      this.mAPI.sendPostAPI(
        `setting/csat/${this.props.editData._id}`,
        tData,
        data => {
          if (data) {
            this.resetAllData();
            this.props.closeModal(true);
            Alert.success(`CSAT ${tData.name} is Updated.`);
          }
        },
        (errorCode, data) => {
          this.apiResponse(errorCode, data);
        },
        'private',
        { id: tData._id },
        'PUT'
      );
    } else {
      this.mAPI.sendPostAPI(
        'setting/csat',
        tData,
        data => {
          if (data && data.message) {
            Alert.success(`${data.message}`);
          } else {
            Alert.success(`Successfully Added`);
          }
          this.resetAllData();
          this.props.update();
          this.props.closeModal(true);
          Alert.success(`CSAT ${tData.name} is Updated.`);
        },
        (errorCode, data) => {
          this.apiResponse(errorCode, data);
        }
      );
    }
  }
  getCSATById(csatId) {
    var that = this;
    this.setState({ loading: true });
    this.mAPI.sendGetAPI(
      `setting/csat/${csatId}`,
      data => {
        that.setState({ ...data[0] });
        that.setState({ loading: false });
        // if (data && data.data) {
        //   that.setState({ listData: data.data });
        // }
      },
      (error, data) => {
        // if( error ){
        // } else {
        //   that.setState({...data[0]});
        // }
      }
    );
  }

  saveAddGreetings(e) {
    e.preventDefault();
    this.setState({
      intro: {
        fileId: uuid.v4(),
        file: this.state.introFile
      },
      showGreetings: false
    })
  }

  renderAddGreetings() {
    return (
      <FormWrapper>
        <ModalButtonDesign>
          <Button
            btnStyle="default"
            size="small"
            icon=""
            onClick={() => {
              this.handleModalGreetings();
            }}
          >
            Add Greetings
          </Button>
          <Modal show={this.state.showGreetings} className="FModal">
            <Modal.Header closeButton onClick={() => this.handleModalGreetings()}>
              <Modal.Title>Add Greetings</Modal.Title>
            </Modal.Header>
            <form onSubmit={e => this.saveAddGreetings(e)}>
              <Modal.Body style={{ padding: '0px 25px 70px 25px' }}>
                <Row>

                  <Tabs
                    defaultActiveKey="uploadfiles"
                    id="uncontrolled-tab-example"
                    className="customTabs"
                  >
                    <Tab eventKey="texttospeech" title="Text to Speech">
                      <FormWrapper>
                        <FormColumn>
                          <h5>Hello</h5>
                        </FormColumn>
                      </FormWrapper>

                    </Tab>
                    <Tab eventKey="uploadfiles" title="Upload Files">
                      <FormWrapper>
                        <FormColumn>
                          <FormGroup>
                            <ControlLabel>Title</ControlLabel>
                            <FormControl
                              type="text"
                              placeholder="Title"
                              value={this.state.title}
                              name="title"
                              required
                              onChange={this.onChange}
                            />
                          </FormGroup>
                        </FormColumn>
                      </FormWrapper>

                      <FormWrapper>
                        <FormColumn>
                          {this.renderFormGroup('File', {
                            defaultValue: '',
                            autoFocus: false,
                            componentClass: 'file',
                            type: 'file',
                            value: '',
                            accept: 'audio/mp3,audio/wav',
                            selectedFile: this.state.file,
                            onChange: e => {
                              if (e.target.files && e.target.files[0]) {
                                this.setState({ file: e.target.files[0] });
                              } else {
                                this.setState({ file: null });
                              }
                            },
                            id: 'file'
                          })}
                        </FormColumn>
                      </FormWrapper>
                    </Tab>
                  </Tabs>


                </Row>
              </Modal.Body>
              <ModalFooter modalType={modalType}>
                <Button
                  className='grey-btn'
                  onClick={() => { this.handleModalGreetings() }}
                  btnStyle="cancel"
                  size="medium"
                >
                  Cancel
                </Button>
                <Button
                  className="blue-btn"
                  btnStyle="default"
                  type="submit"
                  size="medium"
                  style={{ float: 'right' }}
                >
                  Save
                </Button>
              </ModalFooter>
            </form>
          </Modal>
        </ModalButtonDesign>
      </FormWrapper >
    )
  }
  renderAddQuestions() {
    return (
      <FormWrapper>
        <ModalButtonDesign>
          <Button
            btnStyle="default"
            size="small"
            icon=""
            onClick={() => {
              this.handleModalQuestions();
            }}
          >
            Add Questions
          </Button>
          <Modal show={this.state.showQuestions} className="FModal">
            <Modal.Header closeButton onClick={() => this.handleModalQuestions()}>
              <Modal.Title>Add Questions</Modal.Title>
            </Modal.Header>
            <form>
              <Modal.Body style={{ padding: '0px 25px 70px 25px' }}>
                <Row>

                  <Tabs
                    defaultActiveKey="uploadfiles"
                    id="uncontrolled-tab-example"
                    className="customTabs"
                  >
                    <Tab eventKey="texttospeech" title="Text to Speech">
                      <FormWrapper>
                        <FormColumn>
                          <h5>Hello</h5>
                        </FormColumn>
                      </FormWrapper>

                    </Tab>
                    <Tab eventKey="uploadfiles" title="Upload Files">
                      <FormWrapper>
                        <FormColumn>
                          <FormGroup>
                            <ControlLabel>Title</ControlLabel>
                            <FormControl
                              type="text"
                              placeholder="Title"
                              value={this.state.title}
                              name="title"
                              required
                              onChange={this.onChange}
                            />
                          </FormGroup>
                        </FormColumn>
                      </FormWrapper>

                      <FormWrapper>
                        <FormColumn>
                          {this.renderFormGroup('File', {
                            defaultValue: '',
                            autoFocus: false,
                            componentClass: 'file',
                            type: 'file',
                            value: '',
                            accept: 'audio/mp3,audio/wav',
                            selectedFile: this.state.file,
                            onChange: e => {
                              if (e.target.files && e.target.files[0]) {
                                this.setState({ file: e.target.files[0] });
                              } else {
                                this.setState({ file: null });
                              }
                            },
                            id: 'file'
                          })}
                        </FormColumn>
                      </FormWrapper>
                    </Tab>
                  </Tabs>


                </Row>
              </Modal.Body>
              <ModalFooter modalType={modalType}>
                <Button
                  className='grey-btn'
                  onClick={() => { this.handleModalQuestions() }}
                  btnStyle="cancel"
                  size="medium"
                >
                  Cancel
                </Button>
                <Button
                  className="blue-btn"
                  btnStyle="default"
                  type="submit"
                  size="medium"
                  style={{ float: 'right' }}
                >
                  Save
                </Button>
              </ModalFooter>
            </form>
          </Modal>
        </ModalButtonDesign>
      </FormWrapper >
    )
  }

  renderAddGreetingsEnd() {
    return (
      <FormWrapper>
        <ModalButtonDesign>
          <Button
            btnStyle="default"
            size="small"
            icon=""
            onClick={() => {
              this.handleModalGreetingsEnd();
            }}
          >
            Add Greetings
          </Button>
          <Modal show={this.state.showGreetingsEnd} className="FModal">
            <Modal.Header closeButton onClick={() => this.handleModalGreetingsEnd()}>
              <Modal.Title>Add Greetings</Modal.Title>
            </Modal.Header>
            <form>
              <Modal.Body style={{ padding: '0px 25px 70px 25px' }}>
                <Row>

                  <Tabs
                    defaultActiveKey="uploadfiles"
                    id="uncontrolled-tab-example"
                    className="customTabs"
                  >
                    <Tab eventKey="texttospeech" title="Text to Speech">
                      <FormWrapper>
                        <FormColumn>
                          <h5>Hello</h5>
                        </FormColumn>
                      </FormWrapper>

                    </Tab>
                    <Tab eventKey="uploadfiles" title="Upload Files">
                      <FormWrapper>
                        <FormColumn>
                          <FormGroup>
                            <ControlLabel>Title</ControlLabel>
                            <FormControl
                              type="text"
                              placeholder="Title"
                              value={this.state.title}
                              name="title"
                              required
                              onChange={this.onChange}
                            />
                          </FormGroup>
                        </FormColumn>
                      </FormWrapper>

                      <FormWrapper>
                        <FormColumn>
                          {this.renderFormGroup('File', {
                            defaultValue: '',
                            autoFocus: false,
                            componentClass: 'file',
                            type: 'file',
                            value: '',
                            accept: 'audio/mp3,audio/wav',
                            selectedFile: this.state.file,
                            onChange: e => {
                              if (e.target.files && e.target.files[0]) {
                                this.setState({ file: e.target.files[0] });
                              } else {
                                this.setState({ file: null });
                              }
                            },
                            id: 'file'
                          })}
                        </FormColumn>
                      </FormWrapper>
                    </Tab>
                  </Tabs>


                </Row>
              </Modal.Body>
              <ModalFooter modalType={modalType}>
                <Button
                  className='grey-btn'
                  onClick={() => { this.handleModalGreetingsEnd() }}
                  btnStyle="cancel"
                  size="medium"
                >
                  Cancel
                </Button>
                <Button
                  className="blue-btn"
                  btnStyle="default"
                  type="submit"
                  size="medium"
                  style={{ float: 'right' }}
                >
                  Save
                </Button>
              </ModalFooter>
            </form>
          </Modal>
        </ModalButtonDesign>
      </FormWrapper >
    )
  }

  render() {
    const { modalType } = this.props;
    const valid = /^[a-zA-Z\s]+$/;
    const mainContent = (
      <form onSubmit={e => this.saveData(e)}>
        <FormWrapper>
          {/* <FormColumn></FormColumn> */}
          <FormColumn>
            {this.renderFormGroup('Name', {
              placeholder: 'Name',
              autoFocus: true,
              required: true,
              id: 'name',
              type: 'text',
              maxLength: '60',
              value: this.state.name,
              onChange: e => {
                // if (!valid.test(e.target.value)) {
                //   return false;
                // }
                if (e.target && e.target.value) {
                  this.setState({ name: e.target.value });
                } else {
                  this.setState({ name: "" });
                }
              }
            })}
          </FormColumn>
        </FormWrapper>
        <FormWrapper>
          {/* <FormColumn></FormColumn> */}
          <FormColumn>
            {this.renderFormGroup('Description', {
              defaultValue: '',
              placeholder: 'Description',
              autoFocus: false,
              required: true,
              id: 'description',
              value: this.state.description,
              type: 'text',
              onChange: e => {
                if (e.target.value === ' ') {
                  return false;
                }
                this.setState({ description: e.target.value });
              }
            })}
          </FormColumn>
        </FormWrapper>

        <FormGroup>
          <ControlLabel>Method</ControlLabel>
          <Select
            placeholder=""
            clearable={false}
            onChange={item => {
              if (item) {
                this.setState({
                  method: item.value || 'TRANSFER_ON_AGENT_HANGUP'
                });
              } else {
                this.setState({ method: 'TRANSFER_ON_AGENT_HANGUP' });
              }
            }}
            value={this.state.method}
            options={this.generateParamsFromArray(this.assignedToOptions)}
          />
        </FormGroup>

        <ColumnTitle>
          <InfoWrapper>Survey Intro</InfoWrapper>
          <InfoWrapperP>
            This message plays to the caller immediately after the agent
          </InfoWrapperP>

          {this.renderAddGreetings()}

        </ColumnTitle>

        <ColumnTitle>
          <InfoWrapper>Survey Questions</InfoWrapper>
          <InfoWrapperP>
            Ask Your customer how satisfied they were after their today's
            experience.
          </InfoWrapperP>

          <InfoWrapperP style={{ marginTop: '8px', marginBottom: '10px' }}>
            Input Method
          </InfoWrapperP>

          <FormWrapper>
            <FormColumn style={{ paddingRight: '0px' }}>
              <FormControl
                disabled={false}
                defaultChecked={true}
                componentClass="checkbox"
                name="checkbox"
                id="checkbox"
                onChange={e => {
                  this.state.questions.config.keypad = e.target.checked;
                  this.setState({ questions: this.state.questions });
                }}
                value={this.state.checkbox}
              >
                Keypad
              </FormControl>
            </FormColumn>
            <FormColumn style={{ paddingRight: '0px' }}>
              <FormControl
                disabled={false}
                defaultChecked={true}
                componentClass="checkbox"
                name="checkbox"
                id="checkbox"
                onChange={e => {
                  this.state.questions.config.speech = e.target.checked;
                  this.setState({ questions: this.state.questions });
                }}
                value={this.state.checkbox}
              >
                Speech
              </FormControl>
            </FormColumn>
            <FormColumn>
              <FormControl
                disabled={false}
                defaultChecked={false}
                componentClass="checkbox"
                name="checkbox"
                id="checkbox"
                onChange={e => {
                  this.state.questions.config.allowIntruption = e.target.checked;
                  this.setState({ questions: this.state.questions });
                }}
                value={this.state.checkbox}
              >
                Allow Interrupption
              </FormControl>
            </FormColumn>
          </FormWrapper>

          {this.renderAddQuestions()}


        </ColumnTitle>

        <ColumnTitle>
          <InfoWrapper>Thank You Message</InfoWrapper>
          <InfoWrapperP>
            Plays after your customer's response has been received.
          </InfoWrapperP>

          {this.renderAddGreetingsEnd()}
        </ColumnTitle>

        <ModalFooter modalType={modalType}>
          <ButtonCommonTheme
            type='greyModalBtn'
            OnClick={() => this.props.closeModal()}
            size="xl"
          >
            Cancel
          </ButtonCommonTheme>
          <ButtonCommonTheme
            type='blueModalBtn'
            btnType="submit"
            btnStyle="default"
            size="xl"
            style={{ float: 'right' }}
          >
            {this.props.editData && this.props.editData._id ? 'Update' : 'Add'}
          </ButtonCommonTheme>
        </ModalFooter>
      </form>
    );

    return (
      <DataWithLoader
        data={mainContent}
        loading={this.state.loading}
        size={1}
        count={1}
        emptyText="Upload list of DNC numbers."
        emptyImage="/images/emptyDNC.png"
      />
    );
  }
}

CSATAddEdit.propTypes = {
  group: PropTypes.array
};

CSATAddEdit.contextTypes = {
  __: PropTypes.func
};

export default CSATAddEdit;



// WEBPACK FOOTER //
// src/modules/screens/settings/CSAT/components/CSATAddEdit.js